import { useEffect, useRef, useState } from "react";
import GraficoVendedores from "../components/GraficoVendedores";
import GraficoVentasPorVendedor from "../components/GraficoVentasPorVendedor";
import API from "../api";

const Vendedores = () => {
  const [datos, setDatos] = useState([]);
  const [responsables, setResponsables] = useState([]);
  const [aniosDisponibles, setAniosDisponibles] = useState([]);
  const [mesesDisponibles, setMesesDisponibles] = useState([]);

  const [filtros, setFiltros] = useState({ responsables: [], anios: [], meses: [] });
  const [aplicados, setAplicados] = useState({ responsables: [], anios: [], meses: [] });
  const [mostrarDropdown, setMostrarDropdown] = useState({ responsables: false, anios: false, meses: false });

  const [filtroResponsables, setFiltroResponsables] = useState([]);
  const [filtroAnios, setFiltroAnios] = useState([]);
  const [filtroMeses, setFiltroMeses] = useState([]);

  const refResponsables = useRef();
  const refAnios = useRef();
  const refMeses = useRef();

  useEffect(() => {
    fetch(`${API}/CotizacionesOficial`)
      .then((res) => res.json())
      .then((data) => {
        setDatos(data);

        const responsablesUnicos = [...new Set(data.map(d => d.Responsable || ""))].sort();
        const aniosUnicos = [...new Set(data.map(d => new Date(d["Fecha Solicitud"]?.$date || d["Fecha Solicitud"]).getFullYear()))].sort();
        const mesesUnicos = [...new Set(data.map(d => new Date(d["Fecha Solicitud"]?.$date || d["Fecha Solicitud"]).getMonth() + 1))].sort((a, b) => a - b);

        setResponsables(responsablesUnicos);
        setAniosDisponibles(aniosUnicos);
        setMesesDisponibles(mesesUnicos);
      });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!refResponsables.current?.contains(event.target) &&
          !refAnios.current?.contains(event.target) &&
          !refMeses.current?.contains(event.target)) {
        setMostrarDropdown({ responsables: false, anios: false, meses: false });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (tipo) => {
    setMostrarDropdown({ responsables: false, anios: false, meses: false, [tipo]: true });
  };

  const toggleValor = (valor, tipo) => {
    setFiltros(prev => ({
      ...prev,
      [tipo]: prev[tipo].includes(valor) ? prev[tipo].filter(v => v !== valor) : [...prev[tipo], valor]
    }));
  };

  const aplicarFiltros = () => {
    setAplicados({ ...filtros });
  };

  const limpiarFiltros = () => {
    const vacios = { responsables: [], anios: [], meses: [] };
    setFiltros(vacios);
    setAplicados(vacios);
  };

  const nombresMeses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

  return (
    <div className="container my-4">
      <div className="bg-light p-4 rounded shadow-sm mb-4">
        <div className="row g-3 align-items-end">
          {/* RESPONSABLE */}
          <div className="col-md-3 position-relative" ref={refResponsables}>
            <label className="form-label fw-semibold">Responsables:</label>
            <button onClick={() => toggleDropdown("responsables")} className="form-control text-start">
              {filtros.responsables.length > 0 ? `Seleccionados (${filtros.responsables.length})` : "-- Todos --"}
            </button>
            {mostrarDropdown.responsables && (
              <div className="position-absolute bg-white border rounded shadow w-100 mt-1 z-3 overflow-auto" style={{ maxHeight: "200px" }}>
                {responsables.map((r, i) => (
                  <label key={i} className="dropdown-item">
                    <input type="checkbox" className="form-check-input me-2" checked={filtros.responsables.includes(r)} onChange={() => toggleValor(r, "responsables")} />
                    {r}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* AÑOS */}
          <div className="col-md-3 position-relative" ref={refAnios}>
            <label className="form-label fw-semibold">Años:</label>
            <button onClick={() => toggleDropdown("anios")} className="form-control text-start">
              {filtros.anios.length > 0 ? `Seleccionados (${filtros.anios.length})` : "-- Todos --"}
            </button>
            {mostrarDropdown.anios && (
              <div className="position-absolute bg-white border rounded shadow w-100 mt-1 z-3 overflow-auto" style={{ maxHeight: "200px" }}>
                {aniosDisponibles.map((a, i) => (
                  <label key={i} className="dropdown-item">
                    <input type="checkbox" className="form-check-input me-2" checked={filtros.anios.includes(a)} onChange={() => toggleValor(a, "anios")} />
                    {a}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* MESES */}
          <div className="col-md-3 position-relative" ref={refMeses}>
            <label className="form-label fw-semibold">Meses:</label>
            <button onClick={() => toggleDropdown("meses")} className="form-control text-start">
              {filtros.meses.length > 0 ? `Seleccionados (${filtros.meses.length})` : "-- Todos --"}
            </button>
            {mostrarDropdown.meses && (
              <div className="position-absolute bg-white border rounded shadow w-100 mt-1 z-3 overflow-auto" style={{ maxHeight: "200px" }}>
                {mesesDisponibles.map((m, i) => (
                  <label key={i} className="dropdown-item">
                    <input type="checkbox" className="form-check-input me-2" checked={filtros.meses.includes(m)} onChange={() => toggleValor(m, "meses")} />
                    {nombresMeses[m - 1]}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* BOTONES */}
          <div className="col-md-3 d-flex gap-2">
            <button onClick={aplicarFiltros} className="btn btn-primary w-50">Aplicar</button>
            <button onClick={limpiarFiltros} className="btn btn-danger w-50">Limpiar</button>
          </div>
        </div>
      </div>

      <GraficoVendedores
        responsable={aplicados.responsables[0] || ""}
        anios={aplicados.anios}
        meses={aplicados.meses}
      />
      <GraficoVentasPorVendedor
      />
    </div>
  );
};

export default Vendedores;
